// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionFeaturedListings_title__bXJrD","listings":"SectionFeaturedListings_listings__C80Rq","listingCard":"SectionFeaturedListings_listingCard__H2Nkd"};